import { Link ,NavLink } from 'react-router-dom';
import './App.css';
import { motion } from "motion/react";
const navItems = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Skills', path: '/skills' },
  { name: 'Experience', path: '/experience' },
  { name: 'Featured Projects', path: '/featured-projects' },
  { name: 'Contact', path: '/contact' }
];

function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/" className="logo">
        Ali Hasan
      </Link>
      <motion.div className="nav-links"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1}}
      transition={{ duration: 1.6 ,delay:0.2 }}
      viewport={{once:true}}>
        {navItems.map((item) => (
          <NavLink key={item.path} to={item.path} className="nav-link-item">
            {item.name}
          </NavLink>
        ))}
      </motion.div>
    </nav>
  );
}

export default Navbar;
